import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

class AuthService {
  constructor() {
    // Configure axios defaults
    axios.defaults.withCredentials = true;
  }

  async login() {
    window.location.href = `${API_URL}/api/auth/login`;
  }

  async logout() {
    const response = await axios.post(`${API_URL}/api/auth/logout`);
    return response.data;
  }

  async getCurrentUser() {
    const response = await axios.get(`${API_URL}/api/auth/me`);
    // Extraire l'utilisateur de la réponse {success: true, user: {...}}
    return response.data.user || response.data;
  }

  async handleCallback(code) {
    // The callback is typically handled by the backend
    // This method can be used for additional client-side processing
    return this.getCurrentUser();
  }
}

export const authService = new AuthService();